var _a, _b;
var PERIOD_SOURCE_VALUES = {
    P7D: 'P7D',
    P14D: 'P14D',
    P21D: 'P21D',
    P1M: 'P1M',
    P6M: 'P6M',
    P1Y: 'P1Y',
    P2Y: 'P2Y',
    P3Y: 'P3Y',
    P4Y: 'P4Y',
    P5Y: 'P5Y',
    P7Y: 'P7Y',
    P10Y: 'P10Y',
    P15Y: 'P15Y',
};
var PURPOSE_SOURCE_VALUES = {
    MONEY: 'Money',
    REFINANCE_CREDIT: 'RefinanceCredit',
    NEW_CAR: 'NewCar',
    USED_CAR: 'UsedCar',
    MORTGAGE: 'Mortgage',
};
var AMOUNT_LIMITS = {
    MAX: 1000000,
    MIN: 1000,
    STEP: 1000,
};
var PAGES = {
    CREDITS_LANDING: 'creditsLanding',
    REFERRAL_VITRINS: 'referralVitrins',
};
(_a = {},
    _a[PAGES.CREDITS_LANDING] = 'Лендинг подбора',
    _a[PAGES.REFERRAL_VITRINS] = 'Реферальная витрина',
    _a);
(_b = {},
    _b[PAGES.CREDITS_LANDING] = ['/kredity/onlajn/', '/kredity/onlajn-zayavka-na-kredit/'],
    _b[PAGES.REFERRAL_VITRINS] = ['/kredity/'],
    _b);

export { AMOUNT_LIMITS, PAGES, PERIOD_SOURCE_VALUES, PURPOSE_SOURCE_VALUES };
//# sourceMappingURL=sources.js.map
